/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Box, Divider, Theme, useTheme } from '@mui/material';
import React from 'react';
import CopyrightAndSocialMedia from './copyright_and_social_media';
import Description from './description';
// import NewsLetter from './news_letter';
// import { Footer as FooterProps } from '../../types/footer/footer.type';
// import Links from './links';
// import { staticData } from "../../data/staticData";
// import { useFetch } from '../../utils/useFetch.utils';

function Footer(): JSX.Element {
  const theme: Theme = useTheme();
  // const { footer_links, site_details, social_media, terms_and_privacy } = props;
  // const staticData = useFetch();

  return (
    <Box
      sx={{
        width: { xs: '100%' },
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: { xs: 'center' },
        padding: { xs: theme.spacing(0, 1, 2, 1), lg: theme.spacing(0, 8, 0, 8) },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: {
            xs: 'flex-start',
            md: 'space-between',
            lg: 'flex-start',
            xl: 'space-between',
          },
          margin: { xs: theme.spacing(4, 0, 2, 0) },
        }}
      >
        <Description />
        {/* <Box
          sx={{
            width: { xs: 'auto', lg: '50%' },
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            // alignItems: "flex-start",
            // justifyContent: { xs: 'flex-start', lg: 'space-evenly' },
            justifyContent: { xs: 'flex-start' },
            margin: { xs: theme.spacing(0, 0, 2, 0) },
          }}
        >
          {staticData?.footer_links?.map((data) => {
            return <Links key={data.id} id={data?.id!} links={data?.links!} name={data?.name!} />;
          })}
          <Links name={staticData.usefulLinks?.name} links={staticData.usefulLinks?.links}  />
        </Box> */}
        {/* <NewsLetter /> */}
      </Box>
      <Divider flexItem />
      {/**
       * parent component of
       *  social media
       * terms and privacy
       * copyright
       */}
      <CopyrightAndSocialMedia />
    </Box>
  );
};

export default Footer;
